const API_ORIGIN = (process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000/api")
  .replace(/\/api\/?$/i, "")
  .replace(/\/+$/, "");

export function resolveReceiptUrl(url) {
  if (!url || typeof url !== "string") return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${API_ORIGIN}${url.startsWith("/") ? url : `/${url}`}`;
}

export function normalizeExpenseReceipts(expense) {
  const raw =
    expense?.receipts ??
    expense?.receipt_files ??
    expense?.attachments ??
    expense?.files ??
    [];

  if (Array.isArray(expense?.receipt_urls)) {
    return expense.receipt_urls
      .filter(Boolean)
      .map((url, index) => ({
        id: `url-${index}`,
        url: resolveReceiptUrl(url),
        name: String(url).split("/").pop() || `Receipt ${index + 1}`,
      }));
  }

  if (!Array.isArray(raw)) return [];

  if (raw.length > 0 && typeof raw[0] === "string") {
    return raw.map((url, index) => ({
      id: `legacy-${index}`,
      url: resolveReceiptUrl(url),
      name: String(url).split("/").pop() || `Receipt ${index + 1}`,
    }));
  }

  return raw
    .map((receipt, index) => {
      const url =
        receipt?.url ??
        receipt?.file_url ??
        receipt?.path ??
        receipt?.link ??
        receipt?.download_url ??
        "";
      return {
        id: receipt?.id ?? receipt?.uuid ?? `receipt-${index}`,
        url: resolveReceiptUrl(url),
        name:
          receipt?.name ??
          receipt?.file_name ??
          receipt?.original_name ??
          (String(url).split("/").pop() || `Receipt ${index + 1}`),
      };
    })
    .filter((receipt) => receipt.url);
}

export const RECEIPT_ACCEPT = ".pdf,image/jpeg,image/png,image/webp,image/gif,image/heic";

export function formatFileSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
